import dynamic from 'next/dynamic';

const Lottie = dynamic(
  () => import('lottie-react'),
  { ssr: false }
);
// @mui
import {
  Dialog,
  DialogContent,
  Stack,
  Paper,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useResponsive from "../../../hooks/useResponsive";
// components
import Label from '../../../components/Label';
import companyJobPostGuide from '../../../assets/lottie/company-job-post-guide.json';

const BlueText = styled('span')(({ theme }) => ({
  color: theme.palette.secondary.main,
}));

export default function DIOStartDialog({ position, open, closeDialog }) {
  const smUp = useResponsive('up', 'sm');

  return (
    <Dialog open={open} onClose={closeDialog} fullWidth maxWidth="xs">
      <DialogContent sx={{ p: { xs: 3, sm: 4 } }}>
        <Stack direction="row" alignItems="center" spacing={0.5}>
          <Label variant="outlined" color="secondary" sx={{ borderRadius: 2}}>
            #원격 근무
          </Label>
          <Label variant="outlined" color="secondary" sx={{ borderRadius: 2}}>
            #파트타임
          </Label>
          <Label variant="outlined" color="secondary" sx={{ borderRadius: 2}}>
            #4주 단위
          </Label>
        </Stack>
        <Typography variant="h5" sx={{ wordBreak: "keep-all", mt: 1 }}>
          지금부터 어떤 <BlueText>파트타임 {position}</BlueText>를 찾는지 알려주세요!
        </Typography>
        <Paper
          sx={{ mt: 2 }}
        >
          <Lottie
            animationData={companyJobPostGuide}
            loop={true}
            style={{ width: smUp ? 360 : 280, height: smUp ? 360 : 280, display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
          />
        </Paper>
      </DialogContent>
      <DialogActions sx={{ p: { xs: 3, sm: 4 } }}>
        <Button
          variant="contained"
          onClick={closeDialog}
          fullWidth={!smUp}
          size="large"
          sx={{ px: 5 }}
        >
          시작하기
        </Button>
      </DialogActions>
    </Dialog>
  )
}
